import React from 'react';
import Moment from 'moment';
import { withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { userContextActions } from '../../store/userContextStore';
import { getMomentLanguage } from '../../store/apiWrapper';
import { connect } from 'react-redux';
import classnames from 'classnames';

import flagCz from '../../img/vlajka_cz.svg';
import flagCzGray from '../../img/vlajka_cz_gray.svg';
import flagSk from '../../img/vlajka_sk.svg';
import flagSkGray from '../../img/vlajka_sk_gray.svg';
import flagGb from '../../img/vlajka_gb.svg';
import flagGbGray from '../../img/vlajka_gb_gray.svg';
import flagDe from '../../img/vlajka_de.svg';
import flagDeGray from '../../img/vlajka_de_gray.svg';

const langMap = {
    'sk-SK' : { activeFlag: flagSk, inactiveFlag: flagSkGray },
    'cs-CZ' : { activeFlag: flagCz, inactiveFlag: flagCzGray },
    'de-DE' : { activeFlag: flagDe, inactiveFlag: flagDeGray },
    'en-US' : { activeFlag: flagGb, inactiveFlag: flagGbGray }
};

class LanguageSelector extends React.Component {
    render() {
        return (
            <div className={classnames({ 'navbar-flags-wrapper': true, 'center': this.props.centerFlags })} style={{ cursor: 'auto' }}>
                { this.props.showLoading && this.props.langLoading &&
                    <div style={{ position: 'relative' }}>
                        <div className="search-progress searching" style={{ height: 2, position: 'absolute', marginTop: '-0.75em' }}>
                        </div>
                    </div>}
                {this.props.languages.map(l =>
                    <img
                        key={l.code} src={l.active ? langMap[l.code].activeFlag : langMap[l.code].inactiveFlag}
                        className={classnames({ 'navbar-flags': true, 'large': this.props.largeFlags })}
                        style={{ cursor: 'pointer' }} onClick={() => this.changeLanguage(l.code)} />
                )}
            </div>
        )
    }

    changeLanguage(lang) {
        Moment.locale(getMomentLanguage(lang) || 'sk');
        this.props.fetchTranslations(lang, this.props.addTranslationForLanguage, true);
    }
}

export default withLocalize(connect(state => state.userContext, dispatch => bindActionCreators(userContextActions, dispatch))(LanguageSelector));